// extracted by mini-css-extract-plugin
export default {"noExercises":"WithoutExercises_noExercises__siBVB"};